/**
 * Se algum membro de T estiver faltando no array, o tipo vira uma
 * mensagem de erro (que aparece no compilador). Se estiver completo,
 * `unknown` não adiciona nenhuma restrição.
 */
type ErroSeIncompleto<T extends string, Arr extends readonly T[]> = [
  T,
] extends [Arr[number]]
  ? unknown
  : `Faltando no array: ${Exclude<T, Arr[number]>}`;

/**
 * Cria um array que o TypeScript exige conter *todos* os membros de T.
 * A currying existe porque o TS não infere um argumento de tipo e exige
 * outro na mesma chamada — então passamos T explicitamente e deixamos
 * o Arr ser inferido do array.
 */
export function arrayExaustivo<T extends string>() {
  return <Arr extends readonly T[]>(arr: Arr & ErroSeIncompleto<T, Arr>) => arr;
}
